import * as React from "react";
const SvgFiRrCloudsMoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-clouds-moon_svg__a)">
      <path
        fill="#062147"
        d="M2.777 15.513a1.284 1.284 0 0 0-.728 1.543 1 1 0 0 1-1.934.509 3.284 3.284 0 0 1 1.874-3.89 5.3 5.3 0 0 1 .039-2.442 5.534 5.534 0 0 1 7.606-3.768 1 1 0 0 1-.8 1.832 3.63 3.63 0 0 0-1.972-.258 3.58 3.58 0 0 0-2.916 4.27 1.96 1.96 0 0 1-1.17 2.204m21.185-4.357a1.96 1.96 0 0 0-1.55-1.256 5.94 5.94 0 0 1-4.37-2.75 5.87 5.87 0 0 1-.35-4.614A1.95 1.95 0 0 0 17.23.6 1.97 1.97 0 0 0 15.3.069a8.8 8.8 0 0 0-3.011 1.54 8 8 0 0 0-2.31 2.98 1 1 0 0 0 1.824.82 6 6 0 0 1 1.73-2.233 8.7 8.7 0 0 1 2.25-1.237 7.86 7.86 0 0 0 .517 6.194 7.7 7.7 0 0 0 5.8 3.68 7.4 7.4 0 0 1-1.78 1.4 1 1 0 1 0 .983 1.742 9.3 9.3 0 0 0 2.307-1.832 1.96 1.96 0 0 0 .352-1.967m-4.087 9.253a4.62 4.62 0 0 1-3.453 3.445 5 5 0 0 1-.992.123c-1.28.024-7.735.038-9.236 0a3.285 3.285 0 0 1-1.205-6.302 5.3 5.3 0 0 1 .039-2.442 5.548 5.548 0 0 1 10.525-.793c.078.188.406.262.736.323q.164.03.268.056a4.67 4.67 0 0 1 3.318 5.59m-3.834-3.657a2.95 2.95 0 0 1-2.335-1.544 3.6 3.6 0 0 0-3.846-2.17 3.58 3.58 0 0 0-2.917 4.27 1.96 1.96 0 0 1-1.166 2.2 1.284 1.284 0 0 0-.728 1.544 1.26 1.26 0 0 0 1.205.922c1.222.033 7.594.029 9.139 0q.296-.008.586-.074a2.64 2.64 0 0 0 1.947-1.941 2.68 2.68 0 0 0-1.885-3.207"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-clouds-moon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCloudsMoon;
